import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";

interface UseDisableTmaisRaffleProps {
  id?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useDisableTmaisRaffle = ({ id, onSuccess, onError }: UseDisableTmaisRaffleProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError>({
    mutationKey: ['disableTmaisRaffle', id],
    mutationFn: async () => {
      await privateAxios.post(`/tmais/raffles/${id}/disable`);
    },
    onSuccess,
    onError,
  });
};

export default useDisableTmaisRaffle;
